import { render, staticRenderFns } from "./LongStay.vue?vue&type=template&id=a90ae10a&"
import script from "./LongStay.vue?vue&type=script&lang=js&"
export * from "./LongStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports